import notificationError from '@/utils/functions/notificationError';
import { notification } from 'antd';
import { useMutation } from 'react-query';
import { getQuestReportInvoiceRequest } from './Invoice.services';

export function useQuestReportInvoiceRequest() {
  return useMutation(getQuestReportInvoiceRequest, {
    onSuccess() {
      notification.success({
        message: 'O relatório Nota Fiscal foi gerado com sucesso!',
      });
    },

    onError(error) {
      notificationError(error);
    },
  });
}
